import React from 'react';
import { ProductsUIProvider } from './context/ProductsUIContext';
import ProductsTable from './table/ProductsTable';
import ProductHeader from './ProductHeader';
import { Box } from '@mui/material';
import ProductsDropMenu from './ProductsDropMenu';

export function Products () {
    // Main Component
    return (
        <ProductsUIProvider>
            <Box display='flex' flexDirection='column' className='pageContainerFluid'>
                <ProductHeader/>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ProductsDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <ProductsTable/>
                    </div>
                </div>
            </Box>
        </ProductsUIProvider>
    );
}
